const t = /* @__PURE__ */ new Map(), c = {
  methods: {
    eventOn(e, s) {
      t.has(e) ? t.get(e).push(s) : t.set(e, [s]);
    },
    eventEmit(e, s) {
      const n = t.get(e);
      n && n.forEach((a) => {
        a.call(this, s);
      });
    },
    eventRemoveByEventName(e) {
      t.delete(e);
    }
  }
};
export {
  c as default
};
